import { ModalMessageComponent } from './../../../shared/modais/modal-message/modal-message.component';
import { FichaListaHomeContent } from './../model/ficha-lista-home-content.interface';
import { AgenteEndereco } from './../../../services/pesados-brasil/agente-endereco.interface';
import { TipoPropostaEnum } from './../../helpers/tipo-proposta.enum';
import { AgenteService } from './../../../services/pesados-brasil/agente.service';
import { LoginStorage } from './../../../login/login.storage';
import { Router } from '@angular/router';
import { FichaListaSharedService } from './../../ficha-lista/ficha-lista.shared.service';
import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import * as _ from 'lodash';
import moment from 'moment';
import { BehaviorSubject } from 'rxjs';
import { HeaderSort } from '../../ficha-table/header-sort/header-sort';
import { take, takeWhile } from 'rxjs/operators';
import { FichaCadastroHomeFaseIdEnum } from '../model/ficha-lista-home-fase-id.enum';

@Component({
  selector: 'app-ficha-table-home',
  templateUrl: './ficha-table-home.component.html',
  styleUrls: ['./ficha-table-home.component.css'],
})
export class FichaTableHomeComponent implements OnInit, OnDestroy {
  @Input() propostas: FichaListaHomeContent[] = [];
  @Input() idFase: number;

  @Output() emitOrdenacao = new EventEmitter<any>();

  @ViewChild('modalMessage', { static: true })
  modalMessage: ModalMessageComponent;

  public isSos: boolean;

  public isCardEsquerdo: boolean;

  public dataLimiteAtendimento: number;
  public currentSort: BehaviorSubject<HeaderSort> = new BehaviorSubject(
    new HeaderSort()
  );
  public direction = 'desc';

  public sosText: string = ' <i class="fa fa-bell"></i>';

  public isAlive: boolean = true;

  public procurarItem: string;
  public tipoPropostaEnum = TipoPropostaEnum;
  public toolTip: string = '';
  public isBuscandoProposta: boolean = false;
  public showing: boolean = false;
  public agentePesadosBrasil: AgenteEndereco;

  constructor(
    private fichaListaSharedService: FichaListaSharedService,
    private router: Router,
    private loginStorage: LoginStorage,
    private agenteService: AgenteService
  ) {}

  ngOnInit() {
    this.currentSort.pipe(takeWhile(() => this.isAlive)).subscribe((event) => {
      this.emitOrdenacao.emit(event);
    });
  }

  onKeyupProcurarItem() {
    // this.filter();
  }

  ngOnDestroy() {
    this.isAlive = false;
  }

  goToTimeline(proposta: FichaListaHomeContent): void {
    this.isCardEsquerdo = proposta.analyst ? true : false;
    if (this.isCardEsquerdo) {
      this.isSos = proposta.containsSOS;
      // if (this.isSos) {
      //   this.dataLimiteAtendimento =
      //     proposta.statusTimeline.dataLimiteAtendimento;
      // }
    }

    if (
      this.isSos &&
      this.dataLimiteAtendimento &&
      moment(this.dataLimiteAtendimento).isBefore(moment())
    ) {
      this.modalMessage
        .show(
          'Esta ficha foi recusada após expiração do prazo de atendimento da SOS!'
        )
        .modalClose.pipe(take(1))
        .subscribe(() => this.fichaListaSharedService.reloadFichaLista());
    } else if (['CDC LOJA', 'CDC PREMIUM'].includes(proposta.product)) {
      const sigla = 'cdcloja';
      this.router.navigate([`/produtos/${sigla}/timelines`], {
        queryParams: { id: proposta.id },
      });
    } else if (['MICROCREDITO', 'CRÉDITO PESSOAL'].includes(proposta.product)) {
      const sigla = 'cp';
      this.router.navigate([`/produtos/${sigla}/timelines`], {
        queryParams: { id: proposta.id },
      });
    } else {
      this.router.navigate(['/timeline'], {
        queryParams: { idFicha: proposta.id },
      });
    }
  }

  iconeProduto(produto: string): string {
    if (produto) {
      switch (produto.toUpperCase()) {
        case 'CRÉDITO PESSOAL':
          return 'icon credito-pessoal';
        case 'CDC LOJA':
          return 'icon cdc-loja';
        case 'MICROCREDITO':
          return 'icon microcredito';
        default:
          return 'icon financiamento';
      }
    }
    return 'icon financiamento';
  }

  setupTdTitle(vendedor: any): string {
    if (vendedor.email) {
      return `Email: ${vendedor.email}
      Celular: ${vendedor.telCelular}`;
    }
    return '';
  }

  get isLojista(): boolean {
    return this.loginStorage.usuario.tipoUsuarioTO.id === 7;
  }

  get isOperador(): boolean {
    return this.loginStorage.usuario.tipoUsuarioTO.id === 8;
  }

  async getDadosPesadosBrasil(proposta: FichaListaHomeContent) {
    if (this.showing) {
      this.toolTip = '';
      this.showing = !this.showing;
      return;
    }
    this.isBuscandoProposta = true;
    if (proposta.campaign.type === this.tipoPropostaEnum.INDICADA) {
      try {
        this.agentePesadosBrasil = await this.agenteService
          .getDestinationProposal(proposta.id)
          .toPromise();
        this.toolTip = `Proposta indicada ao Veículos Brasil. Agente Destino: ${this.agentePesadosBrasil.code} - ${this.agentePesadosBrasil.name}`;
      } catch (error) {
        this.toolTip =
          'Não conseguimos encontrar as informações da proposta no momento, por favor tente mais tarde';
      }
    } else if (proposta.campaign.type === this.tipoPropostaEnum.RECEBIDA) {
      try {
        this.agentePesadosBrasil = await this.agenteService
          .getOriginatorProposal(proposta.id)
          .toPromise();
        this.toolTip = `Proposta recebida via Veículos Brasil. Agente Origem: ${this.agentePesadosBrasil.code} - ${this.agentePesadosBrasil.name}`;
      } catch (error) {
        this.toolTip =
          'Não conseguimos encontrar as informações da proposta no momento, por favor tente mais tarde';
      }
    }
    this.isBuscandoProposta = false;
    this.showing = !this.showing;
  }

  getPrazoSortColumn() {
    if (this.idFase === FichaCadastroHomeFaseIdEnum.ANALISE) {
      return '';
    }
    if (this.idFase === FichaCadastroHomeFaseIdEnum.APROVADAS) {
      return 'flagAprovadoRessalva';
    }
    if (this.idFase === FichaCadastroHomeFaseIdEnum.RECUSADAS) {
      return 'motivoRecusa';
    }
    return '';
  }
}
